import { QueryClientProvider } from 'react-query';
import type { GetProps } from '@types';
import { queryClient } from '@queryClient';
import addComponent from '@utils/addComponent';
import { $isSDK } from '@stores/sdkStores';
import LibSeqFrameModal from '../LibSeqFrameModal';

type Params = Omit<
  GetProps<typeof LibSeqFrameModal>,
  'onConfirm' | 'onRequestClose'
>;
type Result = Parameters<GetProps<typeof LibSeqFrameModal>['onConfirm']>[0];

const selectLibSeqFrames = (params: Params = {}) => {
  if ($isSDK.getState()) {
    return Promise.resolve({} as Result);
  }
  return new Promise<Result>((resolve) => {
    addComponent((remove) => {
      return (
        <QueryClientProvider client={queryClient}>
          <LibSeqFrameModal
            {...params}
            onConfirm={(result) => {
              resolve(result);
              remove();
            }}
            onRequestClose={() => {
              resolve({} as Result);
              remove();
            }}
          />
        </QueryClientProvider>
      );
    });
  });
};

export default selectLibSeqFrames;
